module.exports = "https://coursera_assets.s3.amazonaws.com/images/a93e5c56eabf1d858155912cb29b5107.png";